/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Order_Events_By_TimeInputs */



/**
* | output |
* | --- |
* | "Sort the Event List by start time." |
*
* @param {Shortcut_Keys_Desc_Order_Events_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_order_events_by_time = /** @type {((inputs?: Shortcut_Keys_Desc_Order_Events_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Order_Events_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trier la liste des evenements par temps de debut.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sortiere die Ereignisliste nach Startzeit.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ordina l'elenco degli eventi in base all'ora di inizio.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отсортируйте список событий по времени начала.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ordenar la lista de eventos por hora de inicio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按开始时间对事件列表进行排序。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント リストを開始時間で並べ替えます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट लिस्ट को प्रारंभ समय के अनुसार क्रमबद्ध करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ordene a lista de eventos por horário de início.")
	return /** @type {LocalizedString} */ ("Sort the Event List by start time.")
});